import React from 'react';
import PropTypes from 'prop-types';

import styles from './Loading.scss';

const Loading = ({loadingText}) => {
	return (
	  <div className={styles.container}>
		  {
			  (loadingText) ? <p>{loadingText}</p> : null
		  }
		  <div className={styles.blobs}>
			  <div className={styles.blobCenter}/>
			  <div className={styles.blob}/>
			  <div className={styles.blob}/>
			  <div className={styles.blob}/>
			  <div className={styles.blob}/>
			  <div className={styles.blob}/>
			  <div className={styles.blob}/>
		  </div>
		  <svg xmlns='https://www.w3.org/2000/svg' version='1.1'>
			  <defs>
				  <filter id='goo'>
					  <feGaussianBlur in='SourceGraphic' stdDeviation='10' result='blur'/>
					  <feColorMatrix
						in='blur'
						mode='matrix'
						values='1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7'
						result='goo'/>
					  <feBlend in='SourceGraphic' in2='goo'/>
				  </filter>
			  </defs>
		  </svg>
	  </div>
	);
};

Loading.propTypes = {
	loadingText: PropTypes.string
};

export default Loading;
